import { useMemo } from 'react';
import '../../internals/89afd3114d9c158f62e0e21a82cf39c4eddcf7acec690559797227aa316f9264.cfe-internal.js';
import { useDragDropManager } from '../2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { useIsomorphicLayoutEffect } from '../e6bd8d9d193665651547f77cb2adacf0dae81d061654707a931bdfc0fd619642.cfe-internal.js';
import { TargetConnector } from '../../internals/08f8b8719c77e3e59e0b43eba9926d066d6f004d8602af04e0df6c7f1b1cf88b.cfe-internal.js';

function useDropTargetConnector(options) {
  var manager = useDragDropManager();
  var connector = useMemo(function () {
    return new TargetConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect(function () {
    connector.dropTargetOptions = options || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDropTarget();
    };
  }, [options]);
  return connector;
}

export { useDropTargetConnector };
